import * as React from "react";
const SvgNavigation = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ...props
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2 4.5 20.29l.71.71L12 18l6.79 3 .71-.71L12 2z",
  fill: "currentColor"
}));
export default SvgNavigation;